const systemMessages = {
  summary: {
    banner: {
      inProgressTitle: "In progress",
      inProgressDescription:
        "Some actions are still being processed. Open details to track progress.",
      partialSuccessTitle: "Import completed with issues",
      partialSuccessDescription:
        "The import finished, but some records were skipped or failed. Review the details for the full breakdown.",
      criticalTitle: "Action required",
      criticalDescription:
        "Some items need your attention. Review the details to take the next steps.",
      warningTitle: "Check recommended",
      warningDescription: "Some items may require a quick review.",
      successTitle: "Completed",
      successDescription: "All items were completed successfully.",
    },
    badge: {
      completed: "{{count}} completed",
      errorsOne: "{{count}} error",
      errorsOther: "{{count}} errors",
      completedWithIssues: "{{count}} completed with issues",
      warningsOne: "{{count}} warning",
      warningsOther: "{{count}} warnings",
      inProcess: "{{count}} in process",
      inProgress: "{{count}} in progress",
      updatesOne: "{{count}} update",
      updatesOther: "{{count}} updates",
    },
    viewDetails: "View details",
    dismissSummaryAria: "Dismiss summary banner",
    dismissTitle: "Dismiss",
  },
  drawer: {
    title: "Notifications",
    description: "Activity details",
    empty: "No notifications",
    sections: {
      errors: "Errors",
      importIssues: "Import issues",
      warnings: "Warnings",
      inProcess: "In process",
    },
    showMore: "Show more +{{hiddenCount}}",
    showLess: "Show less",
    messageItem: {
      viewDetails: "View details",
      dismissAria: "Dismiss",
    },
    successSummary: {
      heading: "Completed",
      lineOne: "1 completed.",
      lineOther: "{{count}} completed.",
      dismissAllAria: "Dismiss all completed",
    },
  },
  entityDetails: {
    defaultTitles: {
      error: "Error details",
      inProcess: "In process details",
      warning: "Warning details",
    },
    description: {
      invoicesAffectedOne: "1 invoice affected",
      invoicesAffectedOther: "{{count}} invoices affected",
      noDetailsGeneric: "No error details available",
      noDetailsWarning: "No warning details available",
      noDetailsInProcess: "No in process details available",
    },
    groupedHint: {
      error:
        "Some errors belong to the same invoice, so they are shown together.",
      inProcess:
        "Some updates belong to the same invoice, so they are shown together.",
      warning:
        "Some warnings refer to the same invoice, so they are shown together.",
    },
    unknownInvoice: "Unknown invoice",
    emptyMessage: {
      error: "No error text",
      generic: "No message",
    },
    moreErrors: "+{{count}} more errors",
    moreItems: "+{{count}} more",
    empty: {
      title: {
        error: "No error details",
        warning: "No warning details",
        inProcess: "No in process details",
      },
      hint: {
        error: "There are no grouped invoice errors to display.",
        warning: "There are no grouped warnings to display.",
        inProcess: "There are no grouped in-process items to display.",
      },
    },
    viewInTable: "View in table",
    viewAllInTable: "View all in table",
    back: "Back",
  },
  importResultDetails: {
    title: "Import result details",
    sections: {
      customers: "Customers",
      banks: "Banks",
      invoices: "Invoices",
    },
    stats: {
      created: "created",
      skipped: "skipped",
      failed: "failed",
      alreadyExist: "already exist",
    },
    errorsHeading: "Error",
    fallbackNoDetails: "No details available",
    copyError: "Copy error",
    copied: "Copied!",
  },
};

export default systemMessages;
